
const state = {
    roomFilterData: null,
};

const mutations = {
    setRoomFilterData(state, data) {
        state.roomFilterData = data;
    },
    resetRoomFilterData(state) {
        state.roomFilterData = null;
    },
};

const actions = {
    saveRoomFilterData({ commit }, room_filter) {
        commit('setRoomFilterData',room_filter)
    },
    resetRoomFilterData({ commit }) {
        commit('resetRoomFilterData')
    },
};
const getters = {
    getRoomFilter (state) {
        return state.roomFilterData
    }
}

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions,
};